/* 🧠 REDUX */
import { store } from "../../Redux/Store";
import { ChangeMapShowCaption, changeModal } from "../../Redux/Actions";

/* 🔧 UTILS */
import { createStep } from "./index";

const isMobile = window.matchMedia("(max-width: 1080px)").matches;

export const mapSteps = (t) => [
    createStep({
      selector: '#select-city',
      stepNumber: 1,
      titleKey: t("tour.map.select-city.title"),
      textKey: t("tour.map.select-city.text"),
    }),
    createStep({
      selector: '#caption-button',
      stepNumber: 2,
      titleKey: t("tour.map.caption-button.title"),
      textKey: t("tour.map.caption-button.text"),
    }),
    createStep({
      selector: '#caption',
      stepNumber: 3,
      titleKey: t("tour.map.caption.title"),
      textKey: t("tour.map.caption.text"),
    }),
    createStep({
      selector: '#equipment-marker',
      stepNumber: 4,
      titleKey: t("tour.map.equipment-marker.title"),
      textKey: t("tour.map.equipment-marker.text"),
    }),
    createStep({
      selector: '#map-popup',
      stepNumber: 5,
      titleKey: t("tour.map.map-popup.title"),
      textKey: t("tour.map.map-popup.text"),
    }),
    createStep({
      selector: '#map-modal',
      stepNumber: 6,
      titleKey: t("tour.map.map-modal.title"),
      textKey: t("tour.map.map-modal.text"),
      position: 'bottom'
    }),
    createStep({
      selector: !isMobile && '#map-popup',
      stepNumber: 7,
      titleKey: t("tour.map.map-popup.title"),
      textKey: t("tour.map.map-popup.text"),
    }),
    createStep({
      selector: '#pinned-equipments',
      stepNumber: 8,
      titleKey: t("tour.map.pinned-equipments.title"),
      textKey: t("tour.map.pinned-equipments.text"),
      position: "left",
    }),
    createStep({
      selector: !isMobile && '#unpin-button',
      stepNumber: 9,
      titleKey: t("tour.map.unpin-button.title"),
      textKey: t("tour.map.unpin-button.text"),
      customClose: () => { 
        store.dispatch(ChangeMapShowCaption(false));
      },
    }),
]

export const handleMapPrevStep = (currentStep, setCurrentStep) => {
    const stepActions = {
        2: () => {
            store.dispatch(ChangeMapShowCaption(false));
            setCurrentStep(1);
        },
        3: () => {
            store.dispatch(ChangeMapShowCaption(true));
            setCurrentStep(2);
        },
        4: () => {
            const hiddenClose = document.querySelector('.hidden-close__button');
            hiddenClose && hiddenClose.click();
            setCurrentStep(3);
        },
        5: () => {
            store.dispatch(changeModal(null));
    
            const equipmentMarker = document.querySelector('#equipment-marker');
            equipmentMarker && equipmentMarker.click();
            setCurrentStep(4);
        },
        6: () => {
            const buttonExpand = document.querySelector('[id^="modal-"]');
            buttonExpand && buttonExpand.click();
    
            setCurrentStep(5);
        },
        7: () => {
            const equipmentMarker = document.querySelector('#equipment-marker');
            equipmentMarker && equipmentMarker.click();
    
            setCurrentStep(6);
        },
    };
  
    if (stepActions[currentStep]) {
        stepActions[currentStep]();
    } else {
        setCurrentStep(currentStep - 1);
    }
};

export const handleMapNextStep = (currentStep, setCurrentStep, setIsOpen) => {
  
    const stepActions = {
        1: () => {      
            store.dispatch(ChangeMapShowCaption(true));
            setTimeout(() => {
                setCurrentStep(2);
            }, 500);
        },
        2: () => {      
            store.dispatch(ChangeMapShowCaption(false));
            setCurrentStep(3);
        },
        3: () => {
            const equipmentMarker = document.querySelector('#equipment-marker');
            equipmentMarker && equipmentMarker.click();
            setCurrentStep(4);
        },
        4: () => {
            const buttonExpand = document.querySelector('[id^="modal-"]');
            buttonExpand && buttonExpand.click();

            const hiddenClose = document.querySelector('.hidden-close__button');
            hiddenClose && hiddenClose.click();

            setCurrentStep(5);
        },
        5: () => {
            if (isMobile) {
                setIsOpen(false);
                setCurrentStep(0);
            } else {
                const equipmentMarker = document.querySelector('#equipment-marker');
                equipmentMarker && equipmentMarker.click();

                setCurrentStep(6);
            }

            store.dispatch(changeModal(null));
        },
        6: () => {
            const buttonPin = document.querySelector('[id^="fixed-"]');
            buttonPin && buttonPin.click();

            setCurrentStep(7);
        },
        8: () => {
            const marker = document.querySelector('#equipment-marker');
            marker && marker.remove();

            const closeCard = document.querySelector('#close-card');
            closeCard && closeCard.click();
        
            setIsOpen(false);
            setCurrentStep(0);
        },
    };

    if (stepActions[currentStep]) {
        stepActions[currentStep]();
    } else {
        setCurrentStep(currentStep + 1);
    }
};
